// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#view-context-manager {
  position: absolute;
  right: 0;
  padding: 6px;
  z-index: 7;
}

#view-context-switcher {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 6;
}

.view-context-icon {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  height: 32px;
  width: 32px;
  color: #fff;
  border: 1px solid #666;
  cursor: pointer;
  background-color: var(--highlight-5);
  font-size: 13.5px;
  user-select: none;
  padding: 2px;
  box-sizing: border-box;

  .svg-wrapper {
    width: 100%;
    height: 100%;
  }
}

.view-context-icon:active {
  filter: brightness(0.9);
}

input.view-context-switcher-tab-renamer {
  width: 90%;
  background-color: var(--highlight-2);
  color: #111;
  margin-right: 5%;
  margin-left: 5%;
  border: 1px solid #666;
  height: 70%;
  margin-bottom: 5%;
  margin-top: 5%;
}

.vc-close-tab-icon {
  color: var(--highlight-4);
  font-size: 20px;
  font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;
  margin-right: 4px;
  margin-left: 3px;
  cursor: pointer;

  &:hover {
    font-weight: bolder;
  }
}

.vc-switcher-tab-title {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
  text-align: center;
}

.global-volume-slider-container {
  z-index: 10000000;
  position: absolute;
  top: 60px;
  right: 41px;
  background-color: #181818;
  height: 132px;
  width: 44px;
  padding-top: 20px;
  padding-bottom: 9px;
}

.add-module-picker-container {
  z-index: 10000000;
  position: absolute;
  top: 120px;
  right: 41px;
  background-color: #181818;
  max-width: 300px;

  .module-description {
    font-size: 13.5px;
    font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;
    padding: 6px 4px;
    min-height: 28px;
    box-sizing: border-box;
    border: 1px solid #88888833;
  }
}

.restart-playback-icon-container svg {
  width: 24px;
  height: 24px;
  margin-top: -3px;
}
`, "",{"version":3,"sources":["webpack://./src/ViewContextManager/ViewContextManager.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;;EAEtB;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,oEAAoE;EACpE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;;EAEf;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,gBAAgB;;EAEhB;IACE,iBAAiB;IACjB,oEAAoE;IACpE,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;EAC7B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":["#view-context-manager {\n  position: absolute;\n  right: 0;\n  padding: 6px;\n  z-index: 7;\n}\n\n#view-context-switcher {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 6;\n}\n\n.view-context-icon {\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n  height: 32px;\n  width: 32px;\n  color: #fff;\n  border: 1px solid #666;\n  cursor: pointer;\n  background-color: var(--highlight-5);\n  font-size: 13.5px;\n  user-select: none;\n  padding: 2px;\n  box-sizing: border-box;\n\n  .svg-wrapper {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.view-context-icon:active {\n  filter: brightness(0.9);\n}\n\ninput.view-context-switcher-tab-renamer {\n  width: 90%;\n  background-color: var(--highlight-2);\n  color: #111;\n  margin-right: 5%;\n  margin-left: 5%;\n  border: 1px solid #666;\n  height: 70%;\n  margin-bottom: 5%;\n  margin-top: 5%;\n}\n\n.vc-close-tab-icon {\n  color: var(--highlight-4);\n  font-size: 20px;\n  font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;\n  margin-right: 4px;\n  margin-left: 3px;\n  cursor: pointer;\n\n  &:hover {\n    font-weight: bolder;\n  }\n}\n\n.vc-switcher-tab-title {\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  flex: 1;\n  text-align: center;\n}\n\n.global-volume-slider-container {\n  z-index: 10000000;\n  position: absolute;\n  top: 60px;\n  right: 41px;\n  background-color: #181818;\n  height: 132px;\n  width: 44px;\n  padding-top: 20px;\n  padding-bottom: 9px;\n}\n\n.add-module-picker-container {\n  z-index: 10000000;\n  position: absolute;\n  top: 120px;\n  right: 41px;\n  background-color: #181818;\n  max-width: 300px;\n\n  .module-description {\n    font-size: 13.5px;\n    font-family: 'Hack', 'Input Mono', 'Input', 'Oxygen Mono', monospace;\n    padding: 6px 4px;\n    min-height: 28px;\n    box-sizing: border-box;\n    border: 1px solid #88888833;\n  }\n}\n\n.restart-playback-icon-container svg {\n  width: 24px;\n  height: 24px;\n  margin-top: -3px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
